export default {
  "menu.welcome": "欢迎",
  "menu.more-blocks": "更多区块",
  "menu.home": "首页",
  "menu.admin": "管理页",
  "menu.admin.sub-page": "二级管理页",
  "menu.login": "登录",
  "menu.register": "注册",
  "menu.register-result": "注册结果",
  "menu.dashboard": "Dashboard",
  "menu.dashboard.analysis": "分析页",
  "menu.dashboard.monitor": "监控页",
  "menu.dashboard.workplace": "工作台",
  "menu.overview": "概况总览",
  "menu.exception.403": "403",
  "menu.exception.404": "404",
  "menu.exception.500": "500",
  "menu.form": "表单页",
  "menu.form.basic-form": "基础表单",
  "menu.form.step-form": "分步表单",
  "menu.form.step-form.info": "分步表单（填写转账信息）",
  "menu.form.step-form.confirm": "分步表单（确认转账信息）",
  "menu.form.step-form.result": "分步表单（完成）",
  "menu.form.advanced-form": "高级表单",
  "menu.list": "列表页",
  "menu.list.table-list": "查询表格",
  "menu.list.basic-list": "标准列表",
  "menu.list.card-list": "卡片列表",
  "menu.list.search-list": "搜索列表",
  "menu.list.search-list.articles": "搜索列表（文章）",
  "menu.list.search-list.projects": "搜索列表（项目）",
  "menu.list.search-list.applications": "搜索列表（应用）",
  "menu.profile": "详情页",
  "menu.profile.basic": "基础详情页",
  "menu.profile.advanced": "高级详情页",
  "menu.result": "结果页",
  "menu.result.success": "成功页",
  "menu.result.fail": "失败页",
  "menu.exception": "异常页",
  "menu.exception.not-permission": "403",
  "menu.exception.not-find": "404",
  "menu.exception.server-error": "500",
  "menu.exception.trigger": "触发错误",
  "menu.account": "个人页",
  "menu.account.center": "个人中心",
  "menu.account.settings": "个人设置",
  "menu.account.personal_info": "个人信息",
  "menu.account.personal_info.id": "ID",
  "menu.account.personal_info.operatorName": "商户名称",
  "menu.account.personal_info.userName": "登录账号",
  "menu.account.personal_info.appid": "AppID",
  "menu.account.personal_info.pid": "上级",
  "menu.account.personal_info.pid.none": "无",
  "menu.account.personal_info.publicKey": "商户公钥",
  "menu.account.personal_info.agentLevel": "代理层级",
  "menu.account.personal_info.agentLevel.2": "一级代理",
  "menu.account.personal_info.agentLevel.3": "二级代理",
  "menu.account.personal_info.agentLevel.4": "普通商户",
  "menu.account.personal_info.agentLevel.unknown": "未知",
  "menu.account.personal_info.contactInformation": "联系方式",
  "menu.account.personal_info.operatorManagerName": "负责人",
  "menu.account.personal_info.region": "服务区地区",
  "menu.account.personal_info.endPoint": "服务地址",
  "menu.account.personal_info.walletMode": "钱包模式",
  "menu.account.personal_info.walletMode.single": "单钱包模式",
  "menu.account.personal_info.walletMode.transfer": "转账模式",
  "menu.account.personal_info.status": "状态",
  "menu.account.personal_info.status.normal": "正常",
  "menu.account.personal_info.status.frozen": "被冻结",
  "menu.account.personal_info.fee": "分成比例",
  "menu.account.personal_info.timeZone": "时区",
  "menu.account.personal_info.ipList": "IP白名单",
  "menu.account.personal_info.loginIp": "登录IP",
  "menu.account.personal_info.loginTime": "上次登录时间",
  "menu.account.personal_info.isOpenGoogleCheck": "谷歌验证",
  "menu.account.personal_info.bindTime": "绑定上级时间",
  "menu.account.personal_info.createdAt": "创建时间",
  "menu.account.personal_info.updatedAt": "更新时间",
  "menu.account.personal_info.remark": "备注",
  "menu.account.personal_info.yes": "是",
  "menu.account.personal_info.no": "否",
  "menu.account.personal_info.fetchFailed": "获取个人信息失败",
  "menu.account.change_password": "修改密码",
  "menu.account.trigger": "触发报错",
  "menu.account.logout": "退出登录",
  "menu.editor": "图形编辑器",
  "menu.editor.flow": "流程编辑器",
  "menu.editor.mind": "脑图编辑器",
  "menu.editor.koni": "拓扑编辑器",
  "menu.config": "配置管理",
  "menu.config.currency_config": "货币配置",
  "menu.config.rtp_config": "RTP 配置",
  "menu.config.bet_config": "Bet 档位配置",
  "menu.safe": "安全管理",
  "menu.safe.warn": "风控预警",
  "menu.safe.logs": "预警日志",
  "menu.safe.loss_analysis": "亏损分析",
  "menu.system": "系统管理",
  "menu.system.menu_manage": "菜单管理",
  "menu.system.manager_list": "管理员列表",
  "menu.system.role_manage": "角色管理",
  "menu.system.operation_logs": "操作日志",
  "menu.system.game_verification": "跑单程序管理",
  "menu.review_center": "审核中心",
  "menu.review_center.my": "我发起的",
  "menu.review_center.pending": "待我审批",
  "menu.merchant": "商户管理",
  "menu.merchant.merchant_members": "商户列表",
  "menu.merchant.merchant_users": "用户管理",
  "menu.merchant.merchant_apply": "商户申请",
  "menu.merchant.merchant_review": "商户发布审核",
  "menu.merchant.bill_manage": "账单管理",
  "menu.merchant.merchant_settle": "手动结单",
  "menu.report": "报表管理",
  "menu.report.flow_report": "流水报表",
  "menu.report.bet_record": "投注记录",
  "menu.report.agent_report": "代理商报表",
  "menu.user_analysis": "用户分析",
  "menu.user_analysis.retention": "留存分析",
  "menu.user_analysis.action": "行为分析",
  "menu.user_analysis.country_area": "地区分析",
  "menu.statics": "统计管理",
  "menu.statics.buybonus": "购买奖金统计",
  "menu.statics.data_analysis": "数据分析",
  "menu.statics.games_analysis": "游戏分析",
  "menu.statics.hall": "大厅统计",
  "menu.games": "游戏管理",
  "menu.game_static": "游戏静态资源",
  "menu.business": "活动管理",
  "menu.business.activity_manage": "活动管理",
  "menu.business.giftspin": "赠送记录",
  "menu.business.whitelist": "用户白名单",
  "menu.develop": "开发配置",
  "menu.system.notice_manage": "公告管理",
  "menu.business.whitelist_record": "用户白名单下注记录",
};
